// extracted by mini-css-extract-plugin
export default {"sideBar":"PageLayoutLogin_sideBar__MGOfV","sideBarTitle":"PageLayoutLogin_sideBarTitle__QubTc","wrapperPageLogin":"PageLayoutLogin_wrapperPageLogin__l7BBd"};